
import { PendingRequest } from './PendingRequest';
import { CompletedRequest } from './CompletedRequest';

export const menu = {
	name: 'ApprovalWorkflow',
	list: [
		{ name: 'PendingRequest', route: PendingRequest.name },
		{ name: 'CompletedRequest', route: CompletedRequest.name },
	],
};
